import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster wl-toaster group"
      position="bottom-right"
      duration={4000}
      closeButton
      toastOptions={{
        classNames: {
          toast: "group toast",
          description: "",
          actionButton: "",
          cancelButton: "",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
